import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { AdUnitForTableDTO } from 'features/inventory/ad-unit/components/AdUnitsTable/types/api'
import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql, permitFields } from 'providers/tanstack-query/utils'

export const AD_UNIT_FOR_TABLE_FRAGMENT = (
  ability: Ability,
): TypedDocumentNode<AdUnitForTableDTO> => gql`
  ${ALERT_FRAGMENT}

  fragment AdUnitForTableFragment on AdUnit {
    ${permitFields<AdUnitForTableDTO>({
      ybAdUnitEnabled: ability.can('read', 'AdUnitField-ybAdUnitEnabled'),
    })}
        
    divId
    domain {
      id
      alerts {
        ...AlertFragment
      }
      name
    }
    fieldAlerts {
      ...AlertFragment
    }
    id
    name
    outOfPage
    path
    prebidStackEnabled
    priceGeniusEnabled
    refresherEnabled
    unfilledRecoveryEnabled
    updatedAt
    viewabilityToolsEnabled
  }
`
